import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { ReportsService, CommonService } from '../../services/index';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';
import * as moment from 'moment';

export interface User {
    name: string;
}

@Component({
    selector: 'dataComparison-tab',
    templateUrl: './dataComparison.component.html'
})

export class dataComparisonComponent implements OnInit {
    @ViewChild('files') filesSel:ElementRef;
    @ViewChild('fileUpload') fileUpload;
    isLoading: boolean = false;
    isLoadMask: Promise<any>;
    files: string;
    title: string;
    reportData = [];
    reportColumns = [];
    excelList = [];
    columnList: any = [];
    misMatchList = [];
    existingList = [];
    duplicateRecords = [];
    errorMessage: string;
    successMessage: string;
    inputFile: any;
    
    @Input() set getPopUp(event) {
        this.reportData = JSON.parse(JSON.stringify(event.reportData).replace(/\:null/gi, "\:\"\""));;
        this.reportColumns = event.reportColumns;
        this.title = event.title;
    }

    constructor(public commonService: CommonService, private reportsService: ReportsService, public bsModalRef: BsModalRef, public toasterService: ToasterService) {

    }

    ngOnInit(): void {
        this.bsModalRef.hide();
    }
    
    uploadFile(sheet) {
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        this.misMatchList = [];
        if ((sheet.target.files.length == 0) || (sheet.target.files.length < 0)) {
            return;
        }
        const file = sheet.target.files[0];
        
        reader.onload = (event) => {
            this.isLoading = true;
            var checkFlag = true;
            const data = reader.result;
            this.errorMessage = '';
            this.successMessage = '';
            this.misMatchList = [];
            this.existingList = [];
            this.duplicateRecords = [];
            workBook = XLSX.read(data, { type: 'binary', cellDates: false });
            jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet, {raw: false, defval: ""});
                return initial;
            }, {});

            if (Object.keys(jsonData).length && jsonData[this.title]) {
                this.excelList = jsonData[this.title];
                this.columnList = Object.keys(this.excelList[0]).map(function(col, index) {
                    let colWidth = col.length < 13 ? 110 : (col.length > 15 ? (col.length > 17 ? 195 : 165) : 150);
                    return {name:col, prop:col, width : colWidth, minWidth : colWidth, maxWidth : colWidth};
                });
                if (this.columnList.length == this.reportColumns.length) {
                    let that =this;
                    let tempList = [];
                    let filterarray = [];
                    this.columnList.unshift({name:'Row No.', prop:'rowNo', width : 80, minWidth : 80, maxWidth : 80});
                    that.excelList.map(function(record, recIndex) {
                        record.rowNo = recIndex + 1;
                        if (record['Date'] && typeof record['Date'] === "object") {
                            record['Date'] = moment(record['Date']).add(1, 'hours').format('DD-MM-YYYY');
                        } else {
                            if (record.Date.length == 10) {
                                record['Date'] = moment(record['Date'], 'DD-MM-YYYY').format('DD-MM-YYYY');
                            } else {
                                record['Date'] = moment(record['Date']).format('DD-MM-YYYY');
                            }
                        }
                        if(tempList.length) {
                            filterarray = tempList.filter(function (data) {
                                return (data.Date == record.Date && data.Name == record.Name && data.mobile == record.mobile);
                            });
                            if (filterarray.length) {
                                that.duplicateRecords.push(record);
                            } else {
                                tempList.push(record);
                            }
                        } else {
                            tempList.push(record);
                        }
                    });

                    if (!this.duplicateRecords.length) {
                        if (checkFlag) {
                            this.misMatchList = this.excelList.filter(function (record, recIndex) {
                                record.rowNo = recIndex + 1;
                                let hasDiffData = false;
                                return that.reportData.find(function (data) {
                                    if(data.date == record['Date'] && data.client_name == record['Name'] && data.mobile == record['mobile']) {
                                        hasDiffData = false;
                                        for (let colIndex = 0; colIndex < that.reportColumns.length; colIndex++) {
                                            if(data[that.reportColumns[colIndex].prop] != record[that.columnList[colIndex + 1].name]) {
                                                hasDiffData = true;
                                                record['hasDiffData'+that.columnList[colIndex + 1].name] = true;
                                                record['hasDiffData'] = true;
                                            }
                                        }
                                    } else {
                                        hasDiffData = true;
                                    }
                                    return !hasDiffData;
                                }) ? false : true;
                            });
                            this.existingList = this.reportData.filter(function (data, recIndex) {
                                data.rowNo = recIndex + 1;
                                let hasDiffData = false;
                                data['hasCRMOnlyData'] = true;
                                return that.excelList.find(function (record) {
                                    if(data.date == record['Date'] && data.client_name == record['Name'] && data.mobile == record['mobile']) {
                                        hasDiffData = false;
                                        data['hasCRMOnlyData'] = false;
                                    } else {
                                        hasDiffData = true;
                                    }
                                    return !hasDiffData;
                                }) ? false : true;
                            });

                            if (this.misMatchList.length || this.existingList.length) {
                                let newRecordCount = this.misMatchList.filter(data => !data.hasDiffData).length;
                                if (this.misMatchList.length - newRecordCount) {
                                    this.errorMessage = (this.misMatchList.length - newRecordCount) + ' mis-match record';
                                }
                                if (newRecordCount) {
                                    this.errorMessage = (this.errorMessage ? (this.errorMessage + (this.existingList.length ? ', ' : ' and ')) : '') + newRecordCount + ' new record is found';
                                }
                                if (this.existingList.length) {
                                    this.errorMessage = (this.errorMessage ? (this.errorMessage + ' and ') : '') + this.existingList.length + ' missing record';
                                }
                            } else {
                                this.successMessage = 'There is no mismatch record';
                            }
                        }
                    } else {
                        sheet.srcElement.value = null;
                        this.errorMessage = this.duplicateRecords.length + ' duplicate record is found, please remove those record from uploaded file and try again.';
                    }
                } else {
                    sheet.srcElement.value = null;
                    this.errorMessage = 'Please upload the file with all columns (' + (this.reportColumns.length -this.columnList.length) + ' Missing)';
                    if(this.columnList.length > this.reportColumns.length) {
                        this.errorMessage = 'Please upload the file with only ' + this.reportColumns.length + ' columns (' + (this.columnList.length - this.reportColumns.length) + ' extra column(s) found)'
                    }
                }
                this.isLoading = false;
            }
            else {
                sheet.srcElement.value = null;
                this.errorMessage = 'The uploaded file is not in expected format, please follow the template';
                this.isLoading = false;
            }
        }
        reader.readAsBinaryString(file);
    }

    getCellClass({ row, column }) {
        return row['hasDiffData' + column.prop] ? " text-danger" : "";
    }

    getRowClass(row) {
        return {
            'text-danger': !row.hasDiffData
        };
    }

    resetComparison() {
        this.fileUpload.nativeElement.value = "";        
        this.errorMessage = '';
        this.successMessage = '';
        this.excelList = [];
        this.columnList = [];
        this.misMatchList = [];
        this.existingList = [];        
        this.duplicateRecords = [];
    }
    
    downloadMismatchRecords(crmOnly, hasData = true) {
        let that = this,
            data = {
                columns: JSON.stringify(crmOnly ? this.reportColumns : this.columnList),
                data: hasData ? (JSON.stringify(crmOnly ? this.existingList : this.misMatchList)) : '[]',
                title: hasData ? 'Mismatch Reocrds' : this.title,
                sampleRecord: true
            };
        this.isLoadMask = this.commonService
            .printing(data)
            .then(function (res: any) {
                if (res['_body']) {
                    var headers = res['headers']["_headers"],
                        //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                        ctype = headers.get('content-type')[0],
                        cdispos = headers.get('content-disposition')[0],//'attachment;filename="New_Title_Report_As_On_14_11_2017.xlsx"',
                        filename = cdispos.replace(/attachment;filename=|"/gi, ''),
                        blob = new Blob([res['_body']], {
                            type: ctype
                        }),
                        link = document.createElement('a');

                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/dataComparison.component.ts